export default __webpack_public_path__ + "static/media/logos_PostgreSQL.53bc1087.png";